<template>
  <div>
    <div class="card">
      <div class="params">
      <v-img class="img" :src="cartItem.picture" />
      <h1><u> <strong>PRODUCT-NAME</strong>   </u>: <span class="header">{{cartItem.name}}</span></h1>
      <br />
      <br />
      <span class="content">
       <u> <strong>PRODUCT-DESCRIPTION</strong>   </u>: {{cartItem.description}}
        <br />
        <br>
        <u> <strong>PRODUCT-PRICE</strong>   </u>: 
        ₦{{cartItem.price}}.00
        <br />
        <br>
         <u> <strong>TOTAL COST FOR THIS ITEM</strong>   </u>: ₦{{subtotal}}.00
        <br />
        <br>
        <div class="item">
          <span>Quantity</span>
          <b-field>
            <b-numberinput
              expanded
              rounded
              class="quantity"
              v-model="cartItem.quantity"
              @input="updateQuantity"
              min="0"
            ></b-numberinput>
          </b-field>
          
            <v-btn icon class @click="removeItem">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
        </div>
      </span>
    </div></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["cartItem"],
  computed: {
    subtotal() {
      return this.cartItem.quantity * this.cartItem.price;
    }
  },
  methods: {
    ...mapActions(["updateCart", "removeItemInCart"]),
    removeItem() {
      let vm = this;
      this.removeItemInCart({
        item: vm.cartItem
      });
      this.commit('saveCart');
    },
    updateQuantity(event) {
      let vm = this;
      this.updateCart({
        item: vm.cartItem,
        quantity: parseInt(event.target.value),
        isAdd: false
      });
    },
  }
};
</script>
<style >
.params{
  margin-left: 2em;
}
.card{
  margin: 2em
}
.item {
  display: flex;
  width: 50%;
}
.img {
  width: 200px;
  margin: auto;
}
.cartItem {
  display: flex;
  margin-top: 1em;
}
.itemCard {
  margin-top: 1em;
  display: flex;
}
.fa1 {
  color: red;
  margin-top: 6em;
}
.name {
  margin-top: 5em;
  margin-left: 1em;
}
.name2 {
  margin-top: 3em;
}
.quantity {
  margin-left: 1em;
}

.header {
  text-align: center;
}
</style>
